'use client'
import { useEffect, useRef } from 'react'

export default function TankPreviewCanvas() {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    let animationId: number
    let t = 0

    const render = () => {
      t += 0.02
      ctx.fillStyle = '#020408'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // Subtle grid
      ctx.strokeStyle = '#1e293b33'
      ctx.lineWidth = 1
      for (let x = 0; x < canvas.width; x += 30) {
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, canvas.height); ctx.stroke()
      }
      for (let y = 0; y < canvas.height; y += 30) {
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(canvas.width, y); ctx.stroke()
      }

      // Tank 1 (Indigo Vanguard) oscillating movement
      const t1x = 100 + Math.sin(t) * 40
      const t1y = 80 + Math.cos(t * 0.5) * 20
      const t1Angle = Math.sin(t) * 0.5

      // Tank 2 (Fuchsia Juggernaut) opposing movement
      const t2x = 300 - Math.sin(t) * 40
      const t2y = 120 - Math.cos(t * 0.5) * 20
      const t2Angle = Math.PI + Math.sin(t) * 0.5

      // Draw Tank 1
      ctx.save()
      ctx.translate(t1x, t1y)
      ctx.rotate(t1Angle)
      ctx.fillStyle = '#1e293b'
      ctx.fillRect(-14, -10, 28, 5)
      ctx.fillRect(-14, 5, 28, 5)
      ctx.shadowBlur = 8
      ctx.shadowColor = '#6366f1'
      ctx.fillStyle = '#6366f1'
      ctx.fillRect(-10, -8, 20, 16)
      ctx.fillStyle = '#cbd5e1'
      ctx.fillRect(0, -3, 16, 6)
      ctx.restore()

      // Draw Tank 2
      ctx.save()
      ctx.translate(t2x, t2y)
      ctx.rotate(t2Angle)
      ctx.fillStyle = '#1e293b'
      ctx.fillRect(-14, -10, 28, 5)
      ctx.fillRect(-14, 5, 28, 5)
      ctx.shadowBlur = 8
      ctx.shadowColor = '#ec4899'
      ctx.fillStyle = '#ec4899'
      ctx.fillRect(-10, -8, 20, 16)
      ctx.fillStyle = '#cbd5e1'
      ctx.fillRect(0, -3, 16, 6)
      ctx.restore()

      // Animated Bullets flying back and forth
      const bx1 = t1x + Math.cos(t1Angle) * 25 + ((t * 80) % 120)
      const by1 = t1y + Math.sin(t1Angle) * 25
      ctx.shadowBlur = 10
      ctx.shadowColor = '#fbbf24'
      ctx.fillStyle = '#fbbf24'
      ctx.beginPath()
      ctx.arc(bx1 % 350, by1, 3, 0, Math.PI * 2)
      ctx.fill()

      const bx2 = t2x + Math.cos(t2Angle) * 25 - ((t * 80) % 120)
      const by2 = t2y + Math.sin(t2Angle) * 25
      ctx.beginPath()
      ctx.arc(350 - (Math.abs(bx2) % 350), by2, 3, 0, Math.PI * 2)
      ctx.fill()
      ctx.shadowBlur = 0

      animationId = requestAnimationFrame(render)
    }

    render()

    return () => cancelAnimationFrame(animationId)
  }, [])

  return (
    <canvas 
      ref={canvasRef} 
      width={360} 
      height={180} 
      className="rounded-2xl border border-indigo-500/30 shadow-2xl bg-[#020408]/90 max-w-full h-auto"
    />
  )
}